import React, { useContext, useEffect, useRef, useState } from 'react';
import { useParams } from 'react-router-dom';

import { Container, Grid, LinearProgress } from '@mui/material';
import { PageHeader } from '../../common';
import { FetchContext, NavContext, NavRoutes } from '../../contexts';
import { TipoContattoContext, TipoContattoProvider } from './TipoContattoContext';
import { TipoDetails } from './components';

const PageContent = (props) => {

    const {
        user
    } = useContext(FetchContext);

    const {
        addBreadcrumbToken,
        setBread,
        goBack,
        navigateTo,
    } = useContext(NavContext);

    const {
        state,
        setState,

        isLoadingTipoContatto,
        getTipoContattoAsync,

        isDeletingTipoContatto,
        deleteTipoContattoAsync,

        isUpdatingTipoContatto,
        updateTipoContattoAsync,

        isAddingTipoContatto,
        addTipoContattoAsync,
    } = useContext(TipoContattoContext)

    const {
        tipoContatto,
    } = state;

    const {
        tipoContattoId,
    } = useParams();

    const formRef = useRef();
    const saveClickHandler = () => {
        if (formRef.current) {
            formRef.current.handleSubmit();
        }
    }

    const tipoDetailsActionClickHandler = async (action, data) => {
        switch (action) {
            case "Submit":
                if (tipoContattoId) {
                    await updateTipoContattoAsync(tipoContattoId, data);
                } else {
                    await addTipoContattoAsync(data);
                    goBack();
                }
                break;
            default:
                break;
        }
    }

    const tipiListActionClickHandler = async (action, data) => {
        switch (action) {
            case "Add":
                window.open(NavRoutes.TipoUfficioAdd, "_blank").focus();
                break;
            case "Delete":
                await deleteTipoContattoAsync(data.id);
                break;
            default:
                break;
        }
    }

    const [isLoading, setIsLoading] = useState(false);
    useEffect(() => {
        setIsLoading(isLoadingTipoContatto || isAddingTipoContatto || isUpdatingTipoContatto);
    }, [isLoadingTipoContatto, isAddingTipoContatto, isUpdatingTipoContatto])

    useEffect(() => {
        if (user && tipoContatto)
            addBreadcrumbToken(tipoContatto.nome);
    }, [tipoContatto, user]);

    useEffect(() => {
        if (user) {
            if (tipoContattoId) {
                getTipoContattoAsync(tipoContattoId);
            } else {
                addBreadcrumbToken("Aggiungi");
                setState({ tipoContatto: { padreId: tipoContatto?.id }, tipi: null });
            }
        }
    }, [tipoContattoId, user]);

    useEffect(() => {
        if (user && tipoContattoId) {
            getTipoContattoAsync(tipoContattoId);
        }
    }, [user]);

    if (!user)
        return <Container>
            <LinearProgress />
        </Container>

    return (
        <>
            <Container>
                {isLoading && <LinearProgress />}
                <Grid container>
                    <Grid item xs={12}>
                        <PageHeader
                            save
                            onSaveClick={saveClickHandler}
                            disabled={isLoading}
                            title="Tipo Attributo"
                            subtitle="Gestisci il tipo attributo" />
                    </Grid>
                    <Grid item xs={12}>
                        <TipoDetails
                            disabled={isLoading}
                            formRef={formRef}
                            onActionClick={tipoDetailsActionClickHandler} />
                    </Grid>
                </Grid>
            </Container>
        </>
    );
}

export const TipoContattoPage = () => {

    return (
        <TipoContattoProvider>
            <PageContent />
        </TipoContattoProvider>
    );
}